<template>
  <div
    class="holiday-page"
    :class="{ 'rtl': currentLang === 'he', 'ltr': currentLang === 'ru' }"
    :dir="currentLang === 'he' ? 'rtl' : 'ltr'"
  >
    <!-- Decorative SVG elements -->
    <div class="decorations">
      <!-- Snowflakes -->
      <svg class="snowflake snowflake-1" viewBox="0 0 100 100" width="40" height="40">
        <path d="M50 0 L50 100 M0 50 L100 50 M15 15 L85 85 M85 15 L15 85" stroke="white" stroke-width="2" fill="none" opacity="0.6"/>
      </svg>
      <svg class="snowflake snowflake-2" viewBox="0 0 100 100" width="30" height="30">
        <path d="M50 0 L50 100 M0 50 L100 50 M15 15 L85 85 M85 15 L15 85" stroke="white" stroke-width="2" fill="none" opacity="0.4"/>
      </svg>
      <svg class="snowflake snowflake-3" viewBox="0 0 100 100" width="50" height="50">
        <path d="M50 0 L50 100 M0 50 L100 50 M15 15 L85 85 M85 15 L15 85" stroke="white" stroke-width="2" fill="none" opacity="0.5"/>
      </svg>
      <svg class="snowflake snowflake-4" viewBox="0 0 100 100" width="25" height="25">
        <path d="M50 0 L50 100 M0 50 L100 50 M15 15 L85 85 M85 15 L15 85" stroke="white" stroke-width="2" fill="none" opacity="0.5"/>
      </svg>
      <svg class="snowflake snowflake-5" viewBox="0 0 100 100" width="35" height="35">
        <path d="M50 0 L50 100 M0 50 L100 50 M15 15 L85 85 M85 15 L15 85" stroke="white" stroke-width="2" fill="none" opacity="0.4"/>
      </svg>

      <!-- Stars -->
      <svg class="star star-1" viewBox="0 0 100 100" width="35" height="35">
        <polygon points="50,0 61,35 98,35 68,57 79,91 50,70 21,91 32,57 2,35 39,35" fill="gold" opacity="0.7"/>
      </svg>
      <svg class="star star-2" viewBox="0 0 100 100" width="25" height="25">
        <polygon points="50,0 61,35 98,35 68,57 79,91 50,70 21,91 32,57 2,35 39,35" fill="gold" opacity="0.5"/>
      </svg>
      <svg class="star star-3" viewBox="0 0 100 100" width="20" height="20">
        <polygon points="50,0 61,35 98,35 68,57 79,91 50,70 21,91 32,57 2,35 39,35" fill="gold" opacity="0.6"/>
      </svg>

      <!-- Christmas Tree - Left -->
      <svg class="christmas-tree tree-left" viewBox="0 0 100 140" width="80" height="112">
        <!-- Tree layers -->
        <polygon points="50,5 20,45 80,45" fill="#228B22"/>
        <polygon points="50,25 15,70 85,70" fill="#228B22"/>
        <polygon points="50,50 10,100 90,100" fill="#228B22"/>
        <!-- Trunk -->
        <rect x="40" y="100" width="20" height="25" fill="#8B4513"/>
        <!-- Star on top -->
        <polygon points="50,0 53,8 62,8 55,13 58,22 50,17 42,22 45,13 38,8 47,8" fill="gold"/>
        <!-- Ornaments -->
        <circle cx="35" cy="55" r="5" fill="#ff0000"/>
        <circle cx="65" cy="55" r="5" fill="#ffd700"/>
        <circle cx="50" cy="40" r="4" fill="#00bfff"/>
        <circle cx="30" cy="80" r="5" fill="#ffd700"/>
        <circle cx="70" cy="80" r="5" fill="#ff0000"/>
        <circle cx="50" cy="70" r="4" fill="#ff69b4"/>
        <circle cx="40" cy="90" r="4" fill="#00bfff"/>
        <circle cx="60" cy="90" r="4" fill="#32cd32"/>
      </svg>

      <!-- Christmas Tree - Right -->
      <svg class="christmas-tree tree-right" viewBox="0 0 100 140" width="70" height="98">
        <polygon points="50,5 20,45 80,45" fill="#228B22"/>
        <polygon points="50,25 15,70 85,70" fill="#228B22"/>
        <polygon points="50,50 10,100 90,100" fill="#228B22"/>
        <rect x="40" y="100" width="20" height="25" fill="#8B4513"/>
        <polygon points="50,0 53,8 62,8 55,13 58,22 50,17 42,22 45,13 38,8 47,8" fill="gold"/>
        <circle cx="35" cy="55" r="5" fill="#ffd700"/>
        <circle cx="65" cy="55" r="5" fill="#ff0000"/>
        <circle cx="50" cy="40" r="4" fill="#ff69b4"/>
        <circle cx="30" cy="80" r="5" fill="#00bfff"/>
        <circle cx="70" cy="80" r="5" fill="#32cd32"/>
        <circle cx="50" cy="70" r="4" fill="#ffd700"/>
      </svg>

      <!-- Gift boxes -->
      <svg class="gift gift-1" viewBox="0 0 60 50" width="50" height="42">
        <rect x="5" y="15" width="50" height="35" fill="#ff0000" rx="3"/>
        <rect x="5" y="15" width="50" height="10" fill="#cc0000" rx="3"/>
        <rect x="25" y="15" width="10" height="35" fill="#ffd700"/>
        <rect x="5" y="25" width="50" height="8" fill="#ffd700"/>
        <!-- Bow -->
        <ellipse cx="30" cy="12" rx="12" ry="8" fill="#ffd700"/>
        <circle cx="30" cy="15" r="5" fill="#ffed4a"/>
      </svg>

      <svg class="gift gift-2" viewBox="0 0 60 50" width="40" height="33">
        <rect x="5" y="15" width="50" height="35" fill="#00aa00" rx="3"/>
        <rect x="5" y="15" width="50" height="10" fill="#008800" rx="3"/>
        <rect x="25" y="15" width="10" height="35" fill="#ff0000"/>
        <rect x="5" y="25" width="50" height="8" fill="#ff0000"/>
        <ellipse cx="30" cy="12" rx="12" ry="8" fill="#ff0000"/>
        <circle cx="30" cy="15" r="5" fill="#ff6666"/>
      </svg>

      <svg class="gift gift-3" viewBox="0 0 60 50" width="35" height="29">
        <rect x="5" y="15" width="50" height="35" fill="#4169e1" rx="3"/>
        <rect x="5" y="15" width="50" height="10" fill="#3155b0" rx="3"/>
        <rect x="25" y="15" width="10" height="35" fill="#silver"/>
        <rect x="5" y="25" width="50" height="8" fill="#c0c0c0"/>
        <ellipse cx="30" cy="12" rx="12" ry="8" fill="#c0c0c0"/>
        <circle cx="30" cy="15" r="5" fill="#e0e0e0"/>
      </svg>

      <!-- Candy canes -->
      <svg class="candy-cane candy-1" viewBox="0 0 40 80" width="30" height="60">
        <path d="M20,80 L20,30 Q20,10 35,10 Q50,10 50,25 Q50,35 40,35 Q30,35 30,25"
              fill="none" stroke="#ff0000" stroke-width="8" stroke-linecap="round"/>
        <path d="M20,80 L20,30 Q20,10 35,10 Q50,10 50,25 Q50,35 40,35 Q30,35 30,25"
              fill="none" stroke="white" stroke-width="8" stroke-linecap="round"
              stroke-dasharray="10,10"/>
      </svg>

      <svg class="candy-cane candy-2" viewBox="0 0 40 80" width="25" height="50">
        <path d="M20,80 L20,30 Q20,10 35,10 Q50,10 50,25 Q50,35 40,35 Q30,35 30,25"
              fill="none" stroke="#ff0000" stroke-width="8" stroke-linecap="round"/>
        <path d="M20,80 L20,30 Q20,10 35,10 Q50,10 50,25 Q50,35 40,35 Q30,35 30,25"
              fill="none" stroke="white" stroke-width="8" stroke-linecap="round"
              stroke-dasharray="10,10"/>
      </svg>

      <!-- Ornament balls hanging -->
      <svg class="ornament ornament-1" viewBox="0 0 40 60" width="30" height="45">
        <line x1="20" y1="0" x2="20" y2="15" stroke="#888" stroke-width="2"/>
        <rect x="15" y="12" width="10" height="6" fill="#ffd700" rx="1"/>
        <circle cx="20" cy="35" r="18" fill="#ff0000"/>
        <ellipse cx="15" cy="28" rx="5" ry="3" fill="rgba(255,255,255,0.3)"/>
      </svg>

      <svg class="ornament ornament-2" viewBox="0 0 40 60" width="25" height="38">
        <line x1="20" y1="0" x2="20" y2="15" stroke="#888" stroke-width="2"/>
        <rect x="15" y="12" width="10" height="6" fill="#ffd700" rx="1"/>
        <circle cx="20" cy="35" r="18" fill="#ffd700"/>
        <ellipse cx="15" cy="28" rx="5" ry="3" fill="rgba(255,255,255,0.3)"/>
      </svg>

      <svg class="ornament ornament-3" viewBox="0 0 40 60" width="28" height="42">
        <line x1="20" y1="0" x2="20" y2="15" stroke="#888" stroke-width="2"/>
        <rect x="15" y="12" width="10" height="6" fill="#ffd700" rx="1"/>
        <circle cx="20" cy="35" r="18" fill="#00bfff"/>
        <ellipse cx="15" cy="28" rx="5" ry="3" fill="rgba(255,255,255,0.3)"/>
      </svg>

      <!-- String lights -->
      <div class="string-lights">
        <span class="light light-red"></span>
        <span class="light light-yellow"></span>
        <span class="light light-green"></span>
        <span class="light light-blue"></span>
        <span class="light light-red"></span>
        <span class="light light-yellow"></span>
        <span class="light light-green"></span>
        <span class="light light-blue"></span>
        <span class="light light-red"></span>
        <span class="light light-yellow"></span>
      </div>
    </div>

    <!-- Language selector -->
    <div class="language-selector">
      <el-radio-group v-model="currentLang" size="small">
        <el-radio-button label="he">עברית</el-radio-button>
        <el-radio-button label="ru">Русский</el-radio-button>
      </el-radio-group>
    </div>

    <!-- Main content area -->
    <div class="content-container" v-show="isReady">
      <!-- Step 1: Club ID Input -->
      <div v-if="currentStep === 1" class="step step-1">
        <img
          src="https://firebasestorage.googleapis.com/v0/b/rosmannext.appspot.com/o/logos%2Fholiday_logo_375x375.png?alt=media&token=d9e17e8c-3bd9-4e13-804f-c1df0af996db"
          alt="Holiday Logo"
          class="holiday-logo"
        />
        <h1 class="title">{{ t('title') }}</h1>
        <p class="subtitle">{{ t('subtitle') }}</p>

        <div class="input-container">
          <el-input
            v-model="clubId"
            :placeholder="t('placeholder')"
            size="large"
            class="club-input"
            @keyup.enter="handleSubmit"
          />
          <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
        </div>

        <el-button
          type="primary"
          size="large"
          class="submit-btn"
          :disabled="clubId.trim().length < 5"
          :loading="isLoading"
          @click="handleSubmit"
        >
          {{ t('submit') }}
        </el-button>

        <a href="#" class="regulations-link" @click.prevent="showRegulations = true">
          {{ t('regulationsLink') }}
        </a>
      </div>

      <!-- Step 2: Countdown -->
      <div v-else-if="currentStep === 2" class="step step-2">
        <img
          src="https://firebasestorage.googleapis.com/v0/b/rosmannext.appspot.com/o/logos%2Fholiday_logo_375x375.png?alt=media&token=d9e17e8c-3bd9-4e13-804f-c1df0af996db"
          alt="Holiday Logo"
          class="holiday-logo"
        />
        <div class="countdown-container">
          <span class="countdown-number" :key="countdown">{{ countdown }}</span>
        </div>
        <p class="countdown-text">{{ t('preparing') }}</p>
      </div>

      <!-- Step 3: Deal Display -->
      <div v-else-if="currentStep === 3" class="step step-3">
        <img
          src="https://firebasestorage.googleapis.com/v0/b/rosmannext.appspot.com/o/logos%2Fholiday_logo_375x375.png?alt=media&token=d9e17e8c-3bd9-4e13-804f-c1df0af996db"
          alt="Holiday Logo"
          class="holiday-logo"
        />
        <div class="congrats-header">
          <div class="confetti confetti-1">🎉</div>
          <div class="confetti confetti-2">🎊</div>
          <div class="confetti confetti-3">✨</div>
          <h1 class="congrats-title">{{ t('congrats') }}</h1>
          <p class="congrats-subtitle">{{ t('youWon') }}</p>
        </div>

        <div class="deal-card" v-if="selectedDeal">
          <!-- Ribbon -->
          <div class="deal-ribbon">{{ t('exclusive') }}</div>

          <!-- Product Title -->
          <h2 class="deal-title">{{ selectedDeal?.title }}</h2>

          <!-- Price Section -->
          <div class="price-section">
            <div class="price-row">
              <span class="price-label">{{ t('originalPrice') }}</span>
              <span class="original-price">₪{{ selectedDeal?.original_price?.toFixed(2) }}</span>
            </div>
            <div class="price-row sale-row">
              <span class="price-label">{{ t('salePrice') }}</span>
              <span class="sale-price">₪{{ selectedDeal?.sale_price?.toFixed(2) }}</span>
            </div>
            <div class="savings-badge">
              {{ t('youSave') }} ₪{{ (selectedDeal?.original_price - selectedDeal?.sale_price)?.toFixed(2) }}
            </div>
          </div>

          <!-- Barcode Section -->
          <div class="barcode-section">
            <span class="barcode-label">{{ t('barcode') }}</span>
            <span class="barcode-value">{{ selectedDeal?.barcode }}</span>
          </div>

          <!-- Restrictions -->
          <div class="restrictions-section">
            <p class="deal-restrictions">{{ selectedDeal?.restrictions?.[currentLang] || selectedDeal?.restrictions?.he }}</p>
          </div>
        </div>

        <p class="redemption-note">{{ t('redemptionNote') }}</p>
        <p class="enjoy-text">{{ t('enjoy') }}</p>
      </div>
    </div>

    <!-- Regulations Modal (CSS only) -->
    <div v-if="showRegulations" class="modal-overlay" @click.self="showRegulations = false">
      <div class="modal-container">
        <div class="modal-header">
          <h2 class="modal-title">{{ t('regulationsTitle') }}</h2>
          <button class="modal-close" @click="showRegulations = false">&times;</button>
        </div>
        <div class="modal-body">
          <div class="regulations-content">
            <h3>תקנון פעילות – "קופסת ההפתעות של רוסמן מרקט"</h3>

            <section>
              <h4>1. הגדרות</h4>
              <p><strong>1.1</strong> "החברה" / "עורכת הפעילות" – רשת רוסמן מרקט ו/או מי מטעמה.</p>
              <p><strong>1.2</strong> "הפעילות" – פעילות "קופסת ההפתעות של רוסמן מרקט" במסגרתה חברי מועדון זכאים לקבלת הטבה באמצעות סריקת קוד QR והזדהות באמצעות מספר תעודת זהות (כפי שנמסר בעת ההצטרפות למועדון).</p>
              <p><strong>1.3</strong> "חבר מועדון" – לקוח בעל חברות פעילה במועדון הלקוחות של רוסמן מרקט.</p>
              <p><strong>1.4</strong> "הטבה" – רכישת מוצר נבחר במחיר מבצע כפי שיופיע לאחר הסריקה/בקופה ובכפוף למלאי ולתנאי תקנון זה.</p>
            </section>

            <section>
              <h4>2. מי רשאי להשתתף</h4>
              <p><strong>2.1</strong> ההשתתפות בפעילות מיועדת לחברי מועדון רוסמן מרקט בלבד.</p>
              <p><strong>2.2</strong> ההשתתפות מותנית בסריקת קוד QR והשלמת תהליך הזדהות באמצעות מספר תעודת זהות של חבר המועדון.</p>
            </section>

            <section>
              <h4>3. אופן ההשתתפות ומימוש ההטבה</h4>
              <p><strong>3.1</strong> חבר מועדון יסרוק את קוד ה-QR המפורסם בסניפים/בנקודות הפעילות.</p>
              <p><strong>3.2</strong> לצורך קבלת ההטבה, חבר המועדון יידרש להזין מספר תעודת זהות שאיתו הצטרף למועדון, לצורך אימות זכאות.</p>
              <p><strong>3.3</strong> לאחר אימות הזכאות, יוצג/יונפק קופון/הטבה למוצר במחיר מבצע, בהתאם לתנאים שיופיעו במערכת ו/או בקופה.</p>
              <p><strong>3.4</strong> מימוש ההטבה יתבצע בקופות הסניפים המשתתפים בפעילות, בהתאם להנחיות שיוצגו במעמד הסריקה ו/או בקופה.</p>
              <p><strong>3.5</strong> ההטבה אישית ואינה ניתנת להעברה, מכירה או החלפה, אלא אם צוין אחרת במפורש.</p>
              <p><strong>3.6</strong> ניתן לממש את ההטבה פעם אחת לכל חבר מועדון במהלך תקופת הפעילות, אלא אם צוין אחרת בפרסום/במערכת.</p>
              <p><strong>3.7</strong> החברה רשאית להגביל מימושים בהתאם לנהלי הפעילות ולמניעת שימוש לרעה.</p>
            </section>

            <section>
              <h4>4. תקופת הפעילות</h4>
              <p><strong>4.1</strong> הפעילות תתקיים בין התאריכים ה-21/12/2025-03/01/2026, בסניפים המשתתפים או עד גמר המלאי.</p>
              <p><strong>4.2</strong> החברה רשאית לקצר/להאריך/להפסיק את הפעילות בכל עת, מכל סיבה, לפי שיקול דעתה, ובכפוף לדין.</p>
            </section>

            <section>
              <h4>5. מלאי ומוצרים</h4>
              <p><strong>5.1</strong> ההטבה תקפה עד גמר המלאי של המוצר/ים הנכללים בהטבה.</p>
              <p><strong>5.2</strong> במקרה של חוסר מלאי, החברה רשאית (אך לא חייבת) להציע מוצר חלופי או להפסיק את האפשרות למימוש, לפי שיקול דעתה.</p>
              <p><strong>5.3</strong> התמונות/המחשות בפרסומים הן להמחשה בלבד.</p>
            </section>

            <section>
              <h4>6. פרטיות ואבטחת מידע</h4>
              <p><strong>6.1</strong> לצורך השתתפות בפעילות, יידרש המשתתף להזין מספר תעודת זהות לצורך אימות זכאות כחבר מועדון.</p>
              <p><strong>6.2</strong> שמירה על פרטיות: מספרי תעודת הזהות המוזנים במסגרת הפעילות אינם נשמרים במסגרת הפעילות עצמה, אינם נשמרים במאגר ייעודי לפעילות זו, ואינם נאגרים/מתועדים מעבר לנדרש לצורך בדיקת זכאות נקודתית בזמן אמת ומתן ההטבה.</p>
              <p><strong>6.3</strong> תהליך האימות והמימוש מתבצע באופן מאובטח, באמצעים טכנולוגיים שנועדו לצמצם חשיפה ולמנוע שימוש בלתי מורשה.</p>
              <p><strong>6.4</strong> החברה ו/או מי מטעמה לא יעשו שימוש בפרטי ההזדהות שהוזנו במסגרת הפעילות לצורך יצירת פנייה/רשומה שיווקית חדשה בעקבות הפעילות עצמה, מעבר לשימושים הרגילים של חברות במועדון ובהתאם לדין ולמדיניות החברה, ככל שחלה.</p>
              <p><strong>6.5</strong> המשתתף מתחייב שלא לבצע פעולות שמטרתן עקיפת מנגנוני אימות/זכאות, ניסיון להזין פרטים שאינם שלו, או כל שימוש לרעה במערכת.</p>
            </section>

            <section>
              <h4>7. אחריות ותקלות</h4>
              <p><strong>7.1</strong> החברה אינה אחראית לתקלות תקשורת/אינטרנט, אי זמינות שירות, תקלות במכשיר הסריקה של המשתתף, או כל תקלה טכנית אחרת שאינה בשליטתה.</p>
              <p><strong>7.2</strong> במקרה של חשד לשימוש לרעה/הונאה/תקלה חריגה, החברה רשאית לחסום מימוש/לבטל זכאות לפעילות לפי שיקול דעתה, בכפוף לדין.</p>
            </section>

            <section>
              <h4>8. שונות</h4>
              <p><strong>8.1</strong> ההשתתפות בפעילות מהווה הסכמה מלאה לתנאי תקנון זה.</p>
              <p><strong>8.2</strong> במקרה של סתירה בין פרסומים שונים לבין תקנון זה – הוראות התקנון יגברו.</p>
              <p><strong>8.3</strong> החברה רשאית לעדכן תקנון זה מעת לעת, וגרסתו המעודכנת היא הקובעת.</p>
            </section>
          </div>
        </div>
        <div class="modal-footer">
          <button class="modal-btn" @click="showRegulations = false">{{ t('close') }}</button>
        </div>
      </div>
    </div>

    <!-- Footer decoration -->
    <div class="footer-decoration">
      <svg viewBox="0 0 400 60" width="100%" height="60" preserveAspectRatio="none">
        <path d="M0 60 Q100 0 200 30 Q300 60 400 20 L400 60 Z" fill="rgba(255,255,255,0.1)"/>
      </svg>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch, nextTick } from 'vue'
import { useRoute } from 'vue-router'
import { projectFirestore, timestamp } from '@/firebase/config'

// Translations
const translations = {
  he: {
    title: 'שנה טובה!',
    subtitle: 'הכנס את מזהה המועדון שלך לקבלת הטבה מיוחדת',
    placeholder: 'הכנס מזהה מועדון',
    submit: 'אישור',
    preparing: 'מתכוננים להפתעה...',
    congrats: 'מזל טוב!',
    youWon: 'זכית בהטבה בלעדית!',
    exclusive: 'הטבה בלעדית',
    originalPrice: 'מחיר רגיל:',
    salePrice: 'מחיר מבצע:',
    youSave: 'חיסכון:',
    barcode: 'ברקוד:',
    enjoy: 'תודה שאתם איתנו, שנה טובה!',
    alreadyUsed: 'מזהה מועדון זה כבר קיבל את ההטבה',
    redemptionNote: 'המימוש הוא בעת הקנייה בקופה',
    regulationsLink: 'לתקנון הפעילות',
    regulationsTitle: 'תקנון הפעילות',
    close: 'סגור'
  },
  ru: {
    title: 'С Новым Годом!',
    subtitle: 'Введите ID клуба для получения специального предложения',
    placeholder: 'Введите ID клуба',
    submit: 'Подтвердить',
    preparing: 'Готовим сюрприз...',
    congrats: 'Поздравляем!',
    youWon: 'Вы выиграли эксклюзивное предложение!',
    exclusive: 'Эксклюзив',
    originalPrice: 'Обычная цена:',
    salePrice: 'Цена акции:',
    youSave: 'Экономия:',
    barcode: 'Штрих-код:',
    enjoy: 'Спасибо, что вы с нами, с Новым Годом!',
    alreadyUsed: 'Этот ID клуба уже получил бонус',
    redemptionNote: 'Погашение осуществляется при покупке на кассе.',
    regulationsLink: 'Правила акции',
    regulationsTitle: 'Правила акции',
    close: 'Закрыть'
  }
}

// Deals array - titles and restrictions in Hebrew
const deals = [
  {
    title: "שרימפס בייבי 500 גרם",
    barcode: "7290013720771",
    original_price: 34.90,
    sale_price: 24.90,
    restrictions: {
      he: "לחברי מועדון בלבד. מוגבל ליחידה אחת. מימוש חד פעמי.",
      ru: "Только для членов клуба. Ограничение: одна единица. Одноразовое использование."
    }
  },
  {
    title: "שמן זית כתית מעולה 750 מ״ל",
    barcode: "7290014692749",
    original_price: 49.90,
    sale_price: 24.90,
    restrictions: {
      he: "לחברי מועדון בלבד. מוגבל ליחידה אחת. מימוש חד פעמי.",
      ru: "Только для членов клуба. Ограничение: одна единица. Одноразовое использование."
    }
  },
  {
    title: "מארז טונה 160X4 גרם סדרה",
    barcode: "7290108504699",
    original_price: 22.90,
    sale_price: 14.90,
    restrictions: {
      he: "לחברי מועדון בלבד. מוגבל ליחידה אחת. מימוש חד פעמי.",
      ru: "Только для членов клуба. Ограничение: одна единица. Одноразовое использование."
    }
  },
  {
    title: "בונבוניירה פררו רושה קולקשן 260 גרם",
    barcode: "8000500247167",
    original_price: 54.90,
    sale_price: 44.90,
    restrictions: {
      he: "לחברי מועדון בלבד. מוגבל ליחידה אחת. מימוש חד פעמי.",
      ru: "Только для членов клуба. Ограничение: одна единица. Одноразовое использование."
    }
  }
];

// Route
const route = useRoute()

// State
const currentLang = ref('he')
const currentStep = ref(1)
const clubId = ref('')
const errorMessage = ref('')
const isLoading = ref(false)
const countdown = ref(10)
const selectedDealIndex = ref(null)
const isReady = ref(false)
const showRegulations = ref(false)

// Computed
const selectedDeal = computed(() => {
  const index = selectedDealIndex.value
  if (index !== null && typeof index === 'number' && index >= 0 && index < deals.length) {
    return deals[index]
  }
  return null
})

// Translation helper
const t = (key) => {
  const lang = translations[currentLang.value] ? currentLang.value : 'he'
  return translations[lang][key] || key
}

// Session storage helpers
const saveToSession = (key, value) => {
  sessionStorage.setItem(`holiday_${key}`, JSON.stringify(value))
}

const getFromSession = (key) => {
  const value = sessionStorage.getItem(`holiday_${key}`)
  return value ? JSON.parse(value) : null
}

const clearSession = () => {
  sessionStorage.removeItem('holiday_currentStep')
  sessionStorage.removeItem('holiday_selectedDealIndex')
  sessionStorage.removeItem('holiday_language')
}

// Handle form submission
const handleSubmit = async () => {
  const trimmedClubId = clubId.value.trim()
  if (trimmedClubId.length < 5) return

  errorMessage.value = ''
  isLoading.value = true

  // Preload Christmas audio on user interaction (unlocks autoplay)
  preloadChristmasAudio()

  try {
    const docRef = projectFirestore.collection('holyday').doc(trimmedClubId)

    // Try to create the document directly
    // Security rules: create allowed, update/read forbidden
    // If doc exists, this will fail with permission error (update denied)
    await docRef.set({
      clubId: trimmedClubId,
      createdAt: timestamp(),
      language: currentLang.value
    })

    // Save to session and move to step 2
    saveToSession('currentStep', 2)
    saveToSession('language', currentLang.value)
    currentStep.value = 2
    startCountdown()
  } catch (error) {
    console.error('Error creating document:', error)
    console.error('Error code:', error.code)
    console.error('Data sent:', {
      clubId: trimmedClubId,
      language: currentLang.value
    })
    // If permission denied, likely means document already exists (update blocked)
    if (error.code === 'permission-denied' || error.message?.includes('permission')) {
      errorMessage.value = t('alreadyUsed')
    } else {
      errorMessage.value = 'שגיאה בתקשורת עם השרת'
    }
  } finally {
    isLoading.value = false
  }
}

// Shared AudioContext (initialized on user interaction)
let audioContext = null

const getAudioContext = () => {
  if (!audioContext) {
    audioContext = new (window.AudioContext || window.webkitAudioContext)()
  }
  // Resume if suspended (browser autoplay policy)
  if (audioContext.state === 'suspended') {
    audioContext.resume()
  }
  return audioContext
}

// Friendly chime sound using Web Audio API
const playBeep = (frequency = 523, duration = 200) => {
  try {
    const ctx = getAudioContext()

    // Create two oscillators for a richer, bell-like sound
    const osc1 = ctx.createOscillator()
    const osc2 = ctx.createOscillator()
    const gainNode = ctx.createGain()

    osc1.connect(gainNode)
    osc2.connect(gainNode)
    gainNode.connect(ctx.destination)

    // Main tone
    osc1.frequency.value = frequency
    osc1.type = 'triangle'

    // Harmonic overtone for richness
    osc2.frequency.value = frequency * 2
    osc2.type = 'sine'

    // Soft attack and gentle decay
    const now = ctx.currentTime
    gainNode.gain.setValueAtTime(0, now)
    gainNode.gain.linearRampToValueAtTime(0.15, now + 0.02) // Soft attack
    gainNode.gain.exponentialRampToValueAtTime(0.01, now + duration / 1000)

    osc1.start(now)
    osc2.start(now)
    osc1.stop(now + duration / 1000)
    osc2.stop(now + duration / 1000)
  } catch (e) {
    console.log('Audio not supported:', e)
  }
}

// Final celebratory chime (magical sound)
const playFinalBeep = () => {
  try {
    const ctx = getAudioContext()
    const now = ctx.currentTime

    // Play a short celebratory arpeggio
    const notes = [523, 659, 784, 1047] // C5, E5, G5, C6 - major chord

    notes.forEach((freq, index) => {
      const osc = ctx.createOscillator()
      const gain = ctx.createGain()

      osc.connect(gain)
      gain.connect(ctx.destination)

      osc.frequency.value = freq
      osc.type = 'triangle'

      const startTime = now + (index * 0.08)
      gain.gain.setValueAtTime(0, startTime)
      gain.gain.linearRampToValueAtTime(0.12, startTime + 0.02)
      gain.gain.exponentialRampToValueAtTime(0.01, startTime + 0.4)

      osc.start(startTime)
      osc.stop(startTime + 0.4)
    })
  } catch (e) {
    console.log('Audio not supported:', e)
  }
}

// Christmas melody (MP3 file)
let christmasAudio = null

const preloadChristmasAudio = () => {
  if (!christmasAudio) {
    christmasAudio = new Audio('/audio/jingle-bells.mp3')
    christmasAudio.volume = 0.5
    christmasAudio.preload = 'auto'
    // Preload by loading metadata
    christmasAudio.load()
    console.log('Christmas audio preloaded')
  }
}

const playChristmasMelody = () => {
  try {
    console.log('Attempting to play Christmas melody...')
    if (!christmasAudio) {
      preloadChristmasAudio()
    }
    christmasAudio.currentTime = 0
    const playPromise = christmasAudio.play()
    if (playPromise !== undefined) {
      playPromise
        .then(() => {
          console.log('Christmas melody playing!')
        })
        .catch(e => {
          console.log('Audio playback failed:', e)
        })
    }
  } catch (e) {
    console.log('Audio not supported:', e)
  }
}

// Stop melody (if needed)
const stopChristmasMelody = () => {
  if (christmasAudio) {
    christmasAudio.pause()
    christmasAudio.currentTime = 0
  }
}

// Countdown logic
const startCountdown = () => {
  countdown.value = 10
  playBeep() // Initial beep

  const interval = setInterval(() => {
    countdown.value--

    if (countdown.value > 0) {
      // Friendly chime, musical notes ascending as we get closer to 0
      // Using pentatonic scale for pleasant sound: C, D, E, G, A
      const pentatonic = [262, 294, 330, 392, 440, 523, 587, 659, 784, 880]
      const noteIndex = Math.min(9 - countdown.value, 9)
      playBeep(pentatonic[noteIndex], 200)
    } else {
      clearInterval(interval)
      playFinalBeep() // Celebratory arpeggio
      selectRandomDeal()
    }
  }, 1000)
}

// Random deal selection
const selectRandomDeal = () => {
  const randomIndex = Math.floor(Math.random() * deals.length)
  selectedDealIndex.value = randomIndex
  saveToSession('selectedDealIndex', randomIndex)
  saveToSession('currentStep', 3)
  currentStep.value = 3

  // Play Christmas melody when deal is revealed
  setTimeout(() => {
    playChristmasMelody()
  }, 500)
}

// Watch language changes
watch(currentLang, (newLang) => {
  saveToSession('language', newLang)
})

// On mount - check session storage and URL params
onMounted(async () => {
  // Check for ?new=1 parameter
  if (route.query.new === '1') {
    clearSession()
    currentStep.value = 1
    isReady.value = true
    return
  }

  // Check session storage for existing state
  const storedDealIndex = getFromSession('selectedDealIndex')
  const storedStep = getFromSession('currentStep')
  const storedLang = getFromSession('language')

  if (storedLang && (storedLang === 'he' || storedLang === 'ru')) {
    currentLang.value = storedLang
  }

  // Validate stored deal index is a valid number within range
  const parsedIndex = typeof storedDealIndex === 'number' ? storedDealIndex : parseInt(storedDealIndex, 10)
  if (!isNaN(parsedIndex) && parsedIndex >= 0 && parsedIndex < deals.length) {
    selectedDealIndex.value = parsedIndex
    // Wait for next tick to ensure reactivity is complete
    await nextTick()
    // Small delay to ensure proper rendering
    setTimeout(() => {
      currentStep.value = 3
      isReady.value = true
    }, 50)
  } else if (storedStep) {
    currentStep.value = storedStep
    isReady.value = true
    if (storedStep === 2) {
      startCountdown()
    }
  } else {
    isReady.value = true
  }
})
</script>

<style scoped>
.holiday-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.holiday-page.rtl {
  direction: rtl;
  text-align: right;
}

.holiday-page.ltr {
  direction: ltr;
  text-align: left;
}

/* LTR specific overrides for Russian */
.holiday-page.ltr .congrats-title,
.holiday-page.ltr .congrats-subtitle,
.holiday-page.ltr .price-label,
.holiday-page.ltr .price-row,
.holiday-page.ltr .barcode-section,
.holiday-page.ltr .barcode-label,
.holiday-page.ltr .deal-restrictions,
.holiday-page.ltr .deal-ribbon,
.holiday-page.ltr .savings-badge,
.holiday-page.ltr .enjoy-text,
.holiday-page.ltr .redemption-note,
.holiday-page.ltr .deal-title,
.holiday-page.ltr .title,
.holiday-page.ltr .subtitle,
.holiday-page.ltr .countdown-text {
  direction: ltr;
  text-align: center;
}


.holiday-page.ltr .restrictions-section {
  direction: ltr;
}

/* Decorations */
.decorations {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  overflow: hidden;
}

.snowflake {
  position: absolute;
  animation: fall linear infinite;
}

.snowflake-1 {
  top: -50px;
  left: 10%;
  animation-duration: 15s;
  animation-delay: 0s;
}

.snowflake-2 {
  top: -50px;
  left: 50%;
  animation-duration: 12s;
  animation-delay: 3s;
}

.snowflake-3 {
  top: -50px;
  right: 15%;
  animation-duration: 18s;
  animation-delay: 6s;
}

.star {
  position: absolute;
  animation: twinkle 2s ease-in-out infinite;
}

.star-1 {
  top: 15%;
  right: 10%;
  animation-delay: 0s;
}

.star-2 {
  top: 25%;
  left: 8%;
  animation-delay: 1s;
}

.star-3 {
  top: 40%;
  right: 5%;
  animation-delay: 0.5s;
}

.snowflake-4 {
  top: -50px;
  left: 30%;
  animation-duration: 14s;
  animation-delay: 2s;
}

.snowflake-5 {
  top: -50px;
  right: 30%;
  animation-duration: 16s;
  animation-delay: 4s;
}

/* Christmas Trees */
.christmas-tree {
  position: absolute;
  bottom: 0;
  filter: drop-shadow(0 0 10px rgba(0, 100, 0, 0.5));
}

.tree-left {
  left: 5%;
  animation: treeGlow 3s ease-in-out infinite;
}

.tree-right {
  right: 5%;
  animation: treeGlow 3s ease-in-out infinite;
  animation-delay: 1.5s;
}

@keyframes treeGlow {
  0%, 100% {
    filter: drop-shadow(0 0 10px rgba(0, 100, 0, 0.5));
  }
  50% {
    filter: drop-shadow(0 0 20px rgba(50, 205, 50, 0.8));
  }
}

/* Gift boxes */
.gift {
  position: absolute;
  bottom: 20px;
  animation: giftBounce 2s ease-in-out infinite;
}

.gift-1 {
  left: 15%;
  animation-delay: 0s;
}

.gift-2 {
  right: 18%;
  animation-delay: 0.5s;
}

.gift-3 {
  left: 25%;
  bottom: 10px;
  animation-delay: 1s;
}

@keyframes giftBounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
}

/* Candy canes */
.candy-cane {
  position: absolute;
  bottom: 30px;
}

.candy-1 {
  left: 3%;
  transform: rotate(-15deg);
}

.candy-2 {
  right: 3%;
  transform: rotate(15deg);
}

/* Ornaments */
.ornament {
  position: absolute;
  top: 0;
  animation: ornamentSwing 3s ease-in-out infinite;
}

.ornament-1 {
  left: 20%;
  animation-delay: 0s;
}

.ornament-2 {
  right: 25%;
  animation-delay: 1s;
}

.ornament-3 {
  left: 40%;
  animation-delay: 2s;
}

@keyframes ornamentSwing {
  0%, 100% {
    transform: rotate(-5deg);
  }
  50% {
    transform: rotate(5deg);
  }
}

/* String lights */
.string-lights {
  position: absolute;
  top: 60px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-around;
  padding: 0 10px;
}

.light {
  width: 12px;
  height: 18px;
  border-radius: 50% 50% 50% 50% / 60% 60% 40% 40%;
  animation: lightGlow 1.5s ease-in-out infinite;
}

.light-red {
  background: #ff0000;
  box-shadow: 0 0 10px #ff0000, 0 0 20px #ff0000;
  animation-delay: 0s;
}

.light-yellow {
  background: #ffd700;
  box-shadow: 0 0 10px #ffd700, 0 0 20px #ffd700;
  animation-delay: 0.3s;
}

.light-green {
  background: #00ff00;
  box-shadow: 0 0 10px #00ff00, 0 0 20px #00ff00;
  animation-delay: 0.6s;
}

.light-blue {
  background: #00bfff;
  box-shadow: 0 0 10px #00bfff, 0 0 20px #00bfff;
  animation-delay: 0.9s;
}

@keyframes lightGlow {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.6;
    transform: scale(0.9);
  }
}

@keyframes fall {
  0% {
    transform: translateY(-100px) rotate(0deg);
  }
  100% {
    transform: translateY(100vh) rotate(360deg);
  }
}

@keyframes twinkle {
  0%, 100% {
    opacity: 0.5;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.2);
  }
}

/* Language selector */
.language-selector {
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
}

.language-selector :deep(.el-radio-group) {
  display: flex;
  gap: 12px;
}

.language-selector :deep(.el-radio-button) {
  --el-border-radius-base: 8px;
}

.language-selector :deep(.el-radio-button__inner) {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  border-radius: 8px !important;
  color: white;
  padding: 8px 20px;
}

.language-selector :deep(.el-radio-button:first-child .el-radio-button__inner),
.language-selector :deep(.el-radio-button:last-child .el-radio-button__inner) {
  border-radius: 8px !important;
}

.language-selector :deep(.el-radio-button__original-radio:checked + .el-radio-button__inner) {
  background: rgba(255, 215, 0, 0.3);
  border-color: gold;
  color: gold;
}

/* Content container */
.content-container {
  max-width: 500px;
  width: 100%;
  z-index: 5;
}

/* Step 1 styles */
.step-1 {
  text-align: center;
}

.title {
  font-size: 3rem;
  color: gold;
  margin-bottom: 10px;
  text-shadow: 0 0 20px rgba(255, 215, 0, 0.5);
}

.subtitle {
  font-size: 1.2rem;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 40px;
}

.input-container {
  margin-bottom: 20px;
}

.club-input {
  max-width: 300px;
  margin: 0 auto;
}

.club-input :deep(.el-input__wrapper) {
  background-color: rgba(30, 30, 60, 0.9) !important;
  border: 2px solid rgba(255, 215, 0, 0.5) !important;
  box-shadow: 0 0 15px rgba(255, 215, 0, 0.2) !important;
}

.club-input :deep(.el-input__inner) {
  color: #ffd700 !important;
  text-align: center;
  font-size: 1.2rem;
  background-color: transparent !important;
  -webkit-text-fill-color: #ffd700 !important;
}

.club-input :deep(.el-input__inner::placeholder) {
  color: rgba(255, 255, 255, 0.6) !important;
  -webkit-text-fill-color: rgba(255, 255, 255, 0.6) !important;
}

.error-message {
  color: #ff6b6b;
  margin-top: 10px;
  font-size: 0.9rem;
}

.submit-btn {
  background: linear-gradient(135deg, #ffd700 0%, #ff8c00 100%);
  border: none;
  padding: 12px 40px;
  font-size: 1.1rem;
  font-weight: bold;
  color: #1a1a2e;
}

.submit-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #ffed4a 0%, #ffa500 100%);
}

.submit-btn:disabled {
  background: rgba(255, 255, 255, 0.2);
  color: rgba(255, 255, 255, 0.5);
}

/* Regulations link */
.regulations-link {
  display: block;
  margin-top: 20px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.9rem;
  text-decoration: underline;
  cursor: pointer;
  transition: color 0.3s ease;
}

.regulations-link:hover {
  color: gold;
}

/* Custom Modal (CSS only) */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 5vh 5%;
}

.modal-container {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  width: 100%;
  max-width: 600px;
  height: 90vh;
  display: flex;
  flex-direction: column;
}

.modal-header {
  background: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
  padding: 15px 20px;
  border-radius: 12px 12px 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
}

.modal-title {
  color: #333;
  font-size: 1.3rem;
  font-weight: bold;
  margin: 0;
}

.modal-close {
  background: none;
  border: none;
  font-size: 1.8rem;
  color: #666;
  cursor: pointer;
  padding: 0;
  line-height: 1;
}

.modal-close:hover {
  color: #333;
}

.modal-body {
  padding: 20px 25px;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
}

.modal-footer {
  background: #f5f5f5;
  border-top: 1px solid #e0e0e0;
  padding: 15px 20px;
  border-radius: 0 0 12px 12px;
  display: flex;
  justify-content: center;
  flex-shrink: 0;
}

.modal-btn {
  background: linear-gradient(135deg, #ffd700 0%, #ff8c00 100%);
  border: none;
  padding: 10px 30px;
  font-size: 1rem;
  font-weight: bold;
  color: #1a1a2e;
  border-radius: 8px;
  cursor: pointer;
}

.modal-btn:hover {
  background: linear-gradient(135deg, #ffed4a 0%, #ffa500 100%);
}

.regulations-content {
  direction: rtl;
  text-align: right;
  color: #333;
  font-size: 1.1rem;
  line-height: 1.8;
}

.regulations-content h3 {
  color: #222;
  font-size: 1.4rem;
  margin-bottom: 20px;
  text-align: center;
  font-weight: bold;
}

.regulations-content h4 {
  color: #333;
  font-size: 1.2rem;
  margin-top: 20px;
  margin-bottom: 12px;
  padding-bottom: 6px;
  border-bottom: 1px solid #e0e0e0;
  font-weight: bold;
}

.regulations-content section {
  margin-bottom: 15px;
}

.regulations-content p {
  margin-bottom: 10px;
  color: #444;
}

.regulations-content strong {
  color: #333;
  margin-left: 5px;
}

/* Scrollbar styling for modal body */
.modal-body::-webkit-scrollbar {
  width: 8px;
}

.modal-body::-webkit-scrollbar-track {
  background: #f0f0f0;
  border-radius: 4px;
}

.modal-body::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 4px;
}

.modal-body::-webkit-scrollbar-thumb:hover {
  background: #aaa;
}

/* Step 2 styles */
.step-2 {
  text-align: center;
}

.step-2 * {
  outline: none !important;
  border: none !important;
  box-shadow: none !important;
}

.countdown-container {
  margin: 0 auto 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  border: none;
  background: transparent;
}

.countdown-number {
  font-size: 8rem;
  font-weight: bold;
  color: gold;
  text-shadow: 0 0 30px rgba(255, 215, 0, 0.8);
  animation: pulse 1s ease-in-out;
  outline: none;
  border: none;
  background: transparent;
  -webkit-tap-highlight-color: transparent;
}

@keyframes pulse {
  0% {
    transform: scale(0.5);
    opacity: 0;
  }
  50% {
    transform: scale(1.2);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.countdown-text {
  font-size: 1.3rem;
  color: rgba(255, 255, 255, 0.8);
}

/* Step 3 styles */
.step-3 {
  text-align: center;
  max-width: 450px;
  width: 100%;
}

.holiday-logo {
  width: 120px;
  height: 120px;
  object-fit: contain;
  margin-bottom: 15px;
  filter: drop-shadow(0 0 20px rgba(255, 215, 0, 0.5));
  animation: logoFadeIn 0.5s ease-out;
}

@keyframes logoFadeIn {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.congrats-header {
  position: relative;
  margin-bottom: 20px;
}

.confetti {
  position: absolute;
  font-size: 1.8rem;
  animation: confettiFall 2s ease-in-out infinite;
  pointer-events: none;
  z-index: 0;
}

.congrats-title,
.congrats-subtitle {
  position: relative;
  z-index: 1;
}

.confetti-1 {
  left: -10px;
  top: 0;
  animation-delay: 0s;
}

.confetti-2 {
  right: -10px;
  top: 0;
  animation-delay: 0.3s;
}

.confetti-3 {
  left: calc(50% - 15px);
  top: -25px;
  animation-delay: 0.6s;
}

@keyframes confettiFall {
  0%, 100% {
    transform: translateY(0) rotate(0deg);
    opacity: 1;
  }
  50% {
    transform: translateY(10px) rotate(15deg);
    opacity: 0.7;
  }
}

.congrats-title {
  font-size: 2.8rem;
  color: gold;
  margin-bottom: 10px;
  text-shadow: 0 0 30px rgba(255, 215, 0, 0.8), 0 0 60px rgba(255, 215, 0, 0.4);
  animation: celebrateIn 0.5s ease-out;
}

.congrats-subtitle {
  font-size: 1.2rem;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 0;
}

@keyframes celebrateIn {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.deal-card {
  position: relative;
  background: linear-gradient(145deg, rgba(20, 20, 50, 0.95) 0%, rgba(30, 30, 70, 0.95) 100%);
  border: 3px solid gold;
  border-radius: 24px;
  padding: 35px 25px 25px;
  margin-bottom: 25px;
  box-shadow:
    0 0 40px rgba(255, 215, 0, 0.4),
    0 10px 40px rgba(0, 0, 0, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
  animation: cardReveal 0.6s ease-out 0.3s both;
  overflow: hidden;
}

.deal-card::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(
    45deg,
    transparent 40%,
    rgba(255, 215, 0, 0.1) 50%,
    transparent 60%
  );
  animation: shimmer 3s infinite;
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%) rotate(45deg);
  }
  100% {
    transform: translateX(100%) rotate(45deg);
  }
}

.deal-ribbon {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(135deg, #ff0000, #cc0000);
  color: white;
  padding: 8px 24px;
  font-size: 0.9rem;
  font-weight: bold;
  border-radius: 0 0 12px 12px;
  box-shadow: 0 4px 15px rgba(255, 0, 0, 0.4);
  z-index: 1;
  text-align: center;
  white-space: nowrap;
  letter-spacing: 1px;
}

@keyframes cardReveal {
  0% {
    transform: translateY(30px) scale(0.9);
    opacity: 0;
  }
  100% {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
}

.deal-title {
  font-size: 1.6rem;
  color: #fff;
  margin-bottom: 20px;
  direction: rtl;
  text-align: center;
  font-weight: 600;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.price-section {
  background: rgba(255, 215, 0, 0.1);
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 20px;
}

.price-row {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  margin-bottom: 10px;
}

.price-label {
  color: rgba(255, 255, 255, 0.7);
  font-size: 1rem;
}

.original-price {
  font-size: 1.3rem;
  color: #ff6b6b;
  text-decoration: line-through;
  opacity: 0.8;
}

.sale-row {
  margin-bottom: 15px;
}

.sale-price {
  font-size: 2.2rem;
  color: #4ade80;
  font-weight: bold;
  text-shadow: 0 0 20px rgba(74, 222, 128, 0.5);
}

.savings-badge {
  background: linear-gradient(135deg, #4ade80, #22c55e);
  color: #000;
  padding: 8px 20px;
  border-radius: 20px;
  font-size: 1rem;
  font-weight: bold;
  display: inline-block;
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(74, 222, 128, 0.4);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 0 20px 5px rgba(74, 222, 128, 0.2);
  }
}

.barcode-section {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 10px;
  padding: 12px 20px;
  margin-bottom: 20px;
}

.barcode-label {
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.9rem;
}

.barcode-value {
  font-family: 'Courier New', monospace;
  font-size: 1.1rem;
  color: #fff;
  letter-spacing: 2px;
  background: rgba(0, 0, 0, 0.3);
  padding: 5px 12px;
  border-radius: 6px;
}

.restrictions-section {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 15px;
}

.deal-restrictions {
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.5);
  line-height: 1.6;
  text-align: center;
}

.redemption-note {
  font-size: 1rem;
  color: #ffd700;
  font-weight: 600;
  margin-bottom: 10px;
  animation: fadeIn 0.5s ease-out 0.7s both;
}

.enjoy-text {
  font-size: 1.1rem;
  color: rgba(255, 255, 255, 0.8);
  animation: fadeIn 0.5s ease-out 0.8s both;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Footer decoration */
.footer-decoration {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  pointer-events: none;
}

/* Responsive */
@media (max-width: 600px) {
  .title {
    font-size: 2.2rem;
  }

  .subtitle {
    font-size: 1rem;
  }

  .countdown-number {
    font-size: 5rem;
  }


  .congrats-title {
    font-size: 2rem;
  }

  .congrats-subtitle {
    font-size: 1rem;
  }

  .deal-title {
    font-size: 1.3rem;
  }

  .deal-card {
    padding: 25px 15px 20px;
    margin: 0 10px 20px;
  }

  .deal-ribbon {
    font-size: 0.8rem;
    padding: 6px 18px;
  }

  .price-section {
    padding: 15px;
  }

  .sale-price {
    font-size: 1.8rem;
  }

  .original-price {
    font-size: 1.1rem;
  }

  .savings-badge {
    font-size: 0.9rem;
    padding: 6px 15px;
  }

  .barcode-section {
    flex-direction: column;
    gap: 5px;
    padding: 10px 15px;
  }

  .barcode-value {
    font-size: 1rem;
  }

  .confetti {
    font-size: 1.5rem;
  }

  .holiday-logo {
    width: 90px;
    height: 90px;
    margin-bottom: 10px;
  }
}

/* Short height screens */
@media (max-height: 700px) {
  .holiday-page {
    padding: 10px;
    justify-content: flex-start;
    padding-top: 60px;
  }

  .holiday-logo {
    width: 70px;
    height: 70px;
    margin-bottom: 8px;
  }

  .congrats-header {
    margin-bottom: 10px;
  }

  .congrats-title {
    font-size: 1.8rem;
    margin-bottom: 5px;
  }

  .congrats-subtitle {
    font-size: 0.95rem;
  }

  .deal-card {
    padding: 25px 15px 15px;
    margin-bottom: 15px;
  }

  .deal-title {
    font-size: 1.2rem;
    margin-bottom: 12px;
  }

  .price-section {
    padding: 12px;
    margin-bottom: 12px;
  }

  .price-row {
    margin-bottom: 6px;
  }

  .sale-price {
    font-size: 1.6rem;
  }

  .original-price {
    font-size: 1rem;
  }

  .savings-badge {
    padding: 5px 12px;
    font-size: 0.85rem;
  }

  .barcode-section {
    padding: 8px 12px;
    margin-bottom: 12px;
  }

  .restrictions-section {
    padding-top: 10px;
  }

  .deal-restrictions {
    font-size: 0.75rem;
  }

  .enjoy-text {
    font-size: 0.95rem;
  }

  .confetti {
    font-size: 1.2rem;
  }
}

/* Very short height screens */
@media (max-height: 550px) {
  .holiday-page {
    padding-top: 50px;
  }

  .holiday-logo {
    width: 50px;
    height: 50px;
    margin-bottom: 5px;
  }

  .congrats-title {
    font-size: 1.5rem;
  }

  .congrats-subtitle {
    font-size: 0.85rem;
  }

  .deal-card {
    padding: 20px 12px 12px;
    margin-bottom: 10px;
  }

  .deal-title {
    font-size: 1.1rem;
    margin-bottom: 10px;
  }

  .deal-ribbon {
    font-size: 0.7rem;
    padding: 4px 14px;
  }

  .price-section {
    padding: 10px;
    margin-bottom: 10px;
  }

  .sale-price {
    font-size: 1.4rem;
  }

  .barcode-section {
    padding: 6px 10px;
    margin-bottom: 8px;
  }

  .enjoy-text {
    font-size: 0.85rem;
  }
}
</style>
